import React, { useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import DialogContentModal from "../components/DialogContent";
import ApplicaionFormatView from "../../Forms/ApplicationView";
import { StatusTable } from "@egovernments/digit-ui-react-components";
import { Card } from "@material-ui/core";
import NOCFormatView from "../../Forms/NOCFormatView";
import { FaFilePdf } from "react-icons/fa";
import ApplicationView12 from "../../Forms/Form12/Application12View";
import ApplicationViewHistory from "../../Forms/Form12/ApplicationHistory";
import PaymentPrint from "@egovernments/digit-ui-module-obps/src/pages/employee/PaymentSlipEmpAll/payment/PaymentSlip";
import TakeActionItem from "../../Forms/TakeActionItem";
import ApplicationViewHistoryAll from "../../Forms/Form12/ApplicationHistoryAll";
import RegistrationSummary from "../../Forms/ProfessionalForm/RegistrationSummary";
import LTPSummary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/ltp-registration/Summary/LTPSummary";
import Summary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/purchasable-Far/summary/Summary";
import { Col, Row } from "react-bootstrap";

const Architect = ({ formData, applicationDocs, totalAmount, actions, avpLogo, daLogo }) => {
  let user = Digit.UserService.getUser();
  console.log("formDataFromAction", formData);

  const { t } = useTranslation();
  const [smShow, setSmShow] = useState(false);
  const [smShowNoc, setSmShowNoc] = useState(false);
  const [smShowPayment, setSmShowPayment] = useState(false);
  const [smShowMs, setSmShowMs] = useState(false);
  const [smShowMsHistory, setSmShowMsHistory] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [formHistory, setFormHistory] = useState("");
  const [smShowMs11, setSmShowMs11] = useState(false);
  const [smShowMsHistory11, setSmShowMsHistory11] = useState(false);

  const closeModal2 = (formData) => {
    if (formData?.oldApplicationType === "FORM_12") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form12");
      if (formData?.oldApplicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_11") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form11");
      if (formData?.oldApplicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_26") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form26");
      if (formData?.oldApplicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_NOC") {
      setIdData(formData?.oldApplicationNo);
      setFormType("formNOC");
      if (formData?.oldApplicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    } else {
      console.log("all", formData?.oldApplicationNo);
    }

    // anchorEl(false)
  };

  const closeModalHistory = (formData) => {
    if (formData?.oldApplicationType === "FORM_12") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form12");
      setFormHistory("WorkHistory");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_11") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form11");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_26") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form26");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_MT") {
      setIdData(formData?.oldApplicationNo);
      setFormType("formMT");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_NOC") {
      setIdData(formData?.oldApplicationNo);
      setFormType("formNOC");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_CLU") {
      setIdData(formData?.oldApplicationNo);
      setFormType("formCLU");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    } else {
      console.log("all", formData?.oldApplicationNo);
    }
  };

  return (
    <React.Fragment>
      <div className="only-white-bg mt-3 mb-3" style={{ borderRadius: "13px", overflow: "hidden" }}>
        <Box display="">
          <div className="application-detail-node">
            Application Details
            <div>
              {formData?.applicationType === "FORM_NOC" && (
                <button
                  className="btn btn-primary border-0 whiteButton p-1 px-3"
                  // style={{
                  //   padding: "6px 12px",
                  //   background: "linear-gradient(22deg, rgb(14, 55, 79) 0%, rgb(38, 86, 112) 100%)",
                  // }}

                  onClick={() => {
                    setSmShowNoc(true), console.log("modal open");
                  }}
                >
                  View Application
                </button>
              )}
              {formData?.applicationType !== "FORM_NOC" && (
                <button
                  className="btn btn-primary whiteButton p-1 px-3 border-0"
                  style={{ padding: "1px" }}
                  onClick={() => {
                    setSmShow(true), console.log("modal open");
                  }}
                >
                  View Application
                </button>
              )}
            </div>
          </div>
          <div className="application-inner-sec">
            <Box gridColumn="span 12">
              {formData?.paymentStatus === "Success" && (
                <button
                  className="btn btn-primary whiteButton p-1 px-3 border-0 mb-3"
                  // style={{ padding: "1px", marginLeft: "2px", paddingLeft: "3%", paddingRight: "3%" }}
                  onClick={() => {
                    setSmShowPayment(true), console.log("modal open");
                  }}
                >
                  Payment Receipt
                </button>
              )}
              {formData?.oldApplicationType === "FORM_12" && (
                <Button
                  variant="contained"
                  color="success"
                  style={{ padding: "1px", marginLeft: "2px", paddingLeft: "3%", paddingRight: "3%" }}
                  onClick={() => closeModal2(formData)}
                >
                  <span style={{ color: "#fff" }}>Old View Application</span>
                </Button>
              )}
              {formData?.oldApplicationType === "FORM_12" && (
                <Button
                  variant="contained"
                  color="success"
                  style={{ padding: "1px", marginLeft: "2px", paddingLeft: "3%", paddingRight: "3%" }}
                  onClick={() => closeModalHistory(formData)}
                >
                  <span style={{ color: "#fff" }}>History old Application</span>
                </Button>
              )}
              {/* Sub- 11,26,MT,NOC */}
              {formData?.oldApplicationType != "FORM_12" && formData?.oldApplicationType && (
                <Button
                  variant="contained"
                  color="success"
                  style={{ padding: "1px", marginLeft: "2px", paddingLeft: "3%", paddingRight: "3%" }}
                  onClick={() => closeModal2(formData)}
                >
                  <span style={{ color: "#fff" }}>Old View Application</span>
                </Button>
              )}
              {formData?.oldApplicationType != "FORM_12" && formData?.oldApplicationType && (
                <Button
                  variant="contained"
                  color="success"
                  style={{ padding: "1px", marginLeft: "2px", paddingLeft: "3%", paddingRight: "3%" }}
                  onClick={() => closeModalHistory(formData)}
                >
                  <span style={{ color: "#fff" }}>History old Application</span>
                </Button>
              )}
            </Box>

            <Row>
              <Col md={6}>
                <Box gridColumn="span 3" sx={{ ml: 1, mb: 2 }}>
                  <b>{t(`BPA_APPLICATION_NUMBER_LABEL`)}</b>
                </Box>
              </Col>
              <Col md={6}>
                <Box gridColumn="span 3" sx={{ ml: 1, mb: 2 }}>
                  : &nbsp;&nbsp; {formData?.applicationNo || ""}
                </Box>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Box gridColumn="span 3" sx={{ ml: 1, mb: 2 }}>
                  <b>Mobile Number</b>
                </Box>
              </Col>
              <Col md={6}>
                <Box gridColumn="span 9" sx={{ ml: 1, mb: 2 }}>
                  {formData?.landInfo?.owners && <div>: &nbsp;&nbsp; {formData?.landInfo?.owners[0]?.mobileNumber}</div>}
                </Box>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Box gridColumn="span 3" sx={{ ml: 1, mb: 2 }}>
                  <b>Applicant Name</b>
                </Box>
              </Col>
              <Col md={6}>
                <Box gridColumn="span 9" sx={{ ml: 1, mb: 2 }}>
                  {formData?.landInfo?.owners && <div>: &nbsp;&nbsp; {formData?.landInfo?.owners[0]?.name}</div>}
                </Box>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Box gridColumn="span 3" sx={{ ml: 1, mb: 2 }}>
                  <b>Applied For </b>
                </Box>
              </Col>
              <Col md={6}>
                <Box gridColumn="span 9" sx={{ ml: 1, mb: 2 }}>
                  : &nbsp;&nbsp; {t(`${formData?.applicationType}`)}
                </Box>
              </Col>
            </Row>
          </div>
          {/* <Box gridColumn="span 3" sx={{ ml: 1 }}>
            <b>Form </b>
          </Box>
          <Box gridColumn="span 9" sx={{ ml: 1 }}>
          {formData?.applicationType === "FORM_11" &&(
            <React.Fragment>
              : &nbsp;&nbsp; Permission for Development/ Subdivision of Land.
            </React.Fragment>
            )}
             {formData?.applicationType === "FORM_26" &&(
            <React.Fragment>
              : &nbsp;&nbsp;   Form of application for composition of offences under section
          39-C read with sub-section (3) of section 39 of the Himachal
          Pradesh  Act, 1977 (Act no. 12 of 1977)..
            </React.Fragment>
             )}
              {formData?.applicationType === "FORM_CLU" &&(
            <React.Fragment>
              : &nbsp;&nbsp;   Change of Land Use
            </React.Fragment>
             )}
              {formData?.applicationType === "FORM_16" &&(
            <React.Fragment>
              : &nbsp;&nbsp;   Form of Application for Appeal. This Form 16 (Application of Appeal) comes under Rule 22.
            </React.Fragment>
             )}
              {formData?.applicationType === "FORM_MT" &&(
            <React.Fragment>
              : &nbsp;&nbsp;  Mobile tower application is used to taking permission for installing the Mobile tower in the premises of TCP, SADA and UD departments.
            </React.Fragment>
             )}
          </Box> */}
          {formData?.structureCertificateUrl && (
            <React.Fragment>
              <Box gridColumn="span 3" sx={{ ml: 2 }}>
                <p className="font-weight-bold" style={{ marginRight: "12px" }}>
                  <b>Structural Stability Certificate</b>
                </p>
              </Box>
              <Box gridColumn="span 9" sx={{ ml: 2 }} style={{ margin: "10px", display: "flex", padding: "5px" }}>
                : &nbsp;&nbsp;{" "}
                <div style={{ marginLeft: "10px" }}>
                  <a target="_" href={formData?.structureCertificateUrl} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                    <p>
                      <FaFilePdf color="#a10505" style={{ width: "20px", height: "30px" }} />
                    </p>
                  </a>
                </div>
              </Box>
            </React.Fragment>
          )}
          {formData?.approvalLetterUrl && (
            <React.Fragment>
              <Box gridColumn="span 3" sx={{ ml: 2 }}>
                <p className="font-weight-bold" style={{ marginLeft: "-7px" }}>
                  <b>Approval Certificate</b>
                </p>
              </Box>
              <Box gridColumn="span 9" sx={{ ml: 2 }} style={{ margin: "10px", display: "flex", padding: "0px" }}>
                : &nbsp;&nbsp;{" "}
                <div>
                  <a target="_" href={formData?.approvalLetterUrl} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                    <p>
                      <FaFilePdf color="#a10505" style={{ width: "20px", height: "30px" }} />
                    </p>
                  </a>
                </div>
              </Box>
            </React.Fragment>
          )}
          {(actions?.[0]?.action === "MAKE_PAYMENT" || formData?.status === "MAKE_PAYMENT_APPLICATION_FEE") && (
            <React.Fragment>
              {formData?.taxHeadEstimate?.map((item, index) => (
                <Box gridColumn="span 12">
                  <Card
                    style={{
                      textAlign: "center",
                      marginBottom: "5px",
                      // backgroundColor: "#99b3d98c",
                      border: "1px solid rgba(91, 90, 95, 0.35)",
                    }}
                  >
                    {formData?.applicationType === "FORM_11" && (
                      <React.Fragment>
                        {formData?.businessService === "BPA_FORM11" && (
                          <div
                            style={{
                              textAlign: "center",
                              backgroundColor: "#99b3d98c",
                              padding: "5px",
                              color: "black",
                              border: " 2px solid rgba(91, 90, 95, 0.35)",
                            }}
                          >
                            <b>Processing Fee </b>
                          </div>
                        )}

                        {formData?.businessService !== "BPA_FORM11" && index === 0 && (
                          <div
                            style={{
                              textAlign: "center",
                              backgroundColor: "#99b3d98c",
                              padding: "5px",
                              color: "black",
                              border: " 2px solid rgba(91, 90, 95, 0.35)",
                            }}
                          >
                            <b>Application Fee </b>
                          </div>
                        )}
                        {formData?.businessService !== "BPA_FORM11" && index === 1 && (
                          <div
                            style={{
                              textAlign: "center",
                              backgroundColor: "#99b3d98c",
                              padding: "5px",
                              color: "black",
                              border: " 2px solid rgba(91, 90, 95, 0.35)",
                            }}
                          >
                            <b>Processing Fee</b>
                          </div>
                        )}
                      </React.Fragment>
                    )}
                    {formData?.applicationType === "FORM_26" && (
                      <React.Fragment>
                        {formData?.businessService === "BPA_FORM26" && index === 0 && (
                          <div
                            style={{
                              textAlign: "center",
                              backgroundColor: "#99b3d98c",
                              padding: "5px",
                              color: "black",
                              border: " 2px solid rgba(91, 90, 95, 0.35)",
                            }}
                          >
                            <b>Application Fee </b>
                          </div>
                        )}
                        {formData?.businessService === "BPA_FORM26" && index === 1 && (
                          <div
                            style={{
                              textAlign: "center",
                              backgroundColor: "#99b3d98c",
                              padding: "5px",
                              color: "black",
                              border: " 2px solid rgba(91, 90, 95, 0.35)",
                            }}
                          >
                            <b>Processing Fee</b>
                          </div>
                        )}
                        {formData?.businessService !== "BPA_FORM26" && (
                          <div
                            style={{
                              textAlign: "center",
                              backgroundColor: "#99b3d98c",
                              padding: "5px",
                              color: "black",
                              border: " 2px solid rgba(91, 90, 95, 0.35)",
                            }}
                          >
                            <b>Processing Fee </b>{" "}
                          </div>
                        )}
                      </React.Fragment>
                    )}

                    {formData?.applicationType === "FORM_26" && item?.feeDetails?.deviationTable && (
                      <>
                        {descriptionOfLand?.typeOfDeviation?.name ===
                          "Plan was approved and deviation beyond permissible limit Upto extent of 10%" && (
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <td>
                                  <p style={{ marginTop: "20px" }}>
                                    <b>Floor Type</b>
                                  </p>
                                </td>
                                <td>
                                  <p style={{ marginTop: "20px" }}>
                                    <b>Use Type</b>
                                  </p>
                                </td>
                                <td>
                                  <td colspan="3">
                                    <b>Builtup Area & Fees</b>
                                  </td>
                                  <tr>
                                    <td style={{ width: "150px" }}>
                                      <b>Area(sq.m)</b>
                                    </td>
                                    <td style={{ width: "150px" }}>
                                      <b>Unit Price()</b>
                                    </td>
                                    <td style={{ width: "150px" }}>
                                      <b>Price()</b>
                                    </td>
                                  </tr>
                                </td>
                                <td>
                                  <td colspan="3">
                                    <b>Deviation Area & Fees</b>
                                  </td>
                                  <tr>
                                    <td style={{ width: "150px" }}>
                                      <b>Area(sq.m)</b>
                                    </td>
                                    <td style={{ width: "150px" }}>
                                      <b>Unit Price()</b>
                                    </td>
                                    <td style={{ width: "150px" }}>
                                      <b>Price()</b>
                                    </td>
                                  </tr>
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {item?.feeDetails?.deviationTable?.map((feeData, index) => (
                                <tr>
                                  <td>{feeData?.floorType?.name}</td>
                                  <td>
                                    <b>{feeData?.landUseType?.name}</b>
                                  </td>
                                  <td>
                                    <td style={{ width: "150px" }}>{feeData?.landUseType?.area}</td>
                                    <td style={{ width: "150px" }}>{feeData?.landUseType?.unitPrice}</td>
                                    <td style={{ width: "150px" }}>{feeData?.landUseType?.price}</td>
                                  </td>
                                  <td>
                                    <td style={{ width: "150px" }}>{feeData?.floorType?.area}</td>
                                    <td style={{ width: "150px" }}>{feeData?.floorType?.unitPrice}</td>
                                    <td style={{ width: "150px" }}>{feeData?.floorType?.price}</td>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </>
                    )}

                    <div
                      style={{
                        marginRight: "1%",
                        marginLeft: "1%",
                      }}
                    >
                      {formData?.applicationType === "FORM_26" && item?.feeDetails?.deviationTable && (
                        <>
                          {(descriptionOfLand?.typeOfDeviation?.name === "Plan was not approved and construction carried out without deviation" ||
                            descriptionOfLand?.typeOfDeviation?.name ===
                              "Plan was not approved and deviation beyond permissible limit Upto the extent of 10%") && (
                            <table class="table table-sm">
                              <thead>
                                <tr>
                                  <td>
                                    <p style={{ marginTop: "20px", textAlign: "center" }}>
                                      <b>Use Type</b>
                                    </p>
                                  </td>
                                  <td>
                                    <td colspan="3" style={{ textAlign: "center" }}>
                                      <b>Builtup Area & Fees</b>
                                    </td>
                                    <tr>
                                      <td style={{ width: "300px" }}>
                                        <b>Area(sq.m)</b>
                                      </td>
                                      <td style={{ width: "300px" }}>
                                        <b>Unit Price * Sub Price</b>
                                      </td>
                                      <td style={{ width: "300px" }}>
                                        <b>Price()</b>
                                      </td>
                                    </tr>
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                {item?.feeDetails?.deviationTable?.map((feeData, index) => (
                                  <tr>
                                    <td>
                                      <b>{feeData?.landUseType?.name}</b>
                                    </td>
                                    <td>
                                      <td style={{ width: "300px" }}>{feeData?.landUseType?.area}</td>
                                      <td style={{ width: "300px" }}>
                                        {feeData?.landUseType?.unitPrice} * {feeData?.landUseType?.subPrice}
                                      </td>
                                      <td style={{ width: "300px" }}>{feeData?.landUseType?.price}</td>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </>
                      )}
                    </div>
                    <div
                      style={{
                        marginRight: "1%",
                        marginLeft: "1%",
                      }}
                    >
                      {formData?.applicationType === "FORM_26" && item?.feeDetails?.deviationTable && (
                        <>
                          {descriptionOfLand?.typeOfDeviation?.name ===
                            "Building constructed on under size plot to the extent of 10% less than the permissible plot size" && (
                            <table class="table table-sm">
                              <thead>
                                <tr>
                                  <td>
                                    <p style={{ marginTop: "20px", textAlign: "center" }}>
                                      <b>Use Type</b>
                                    </p>
                                  </td>
                                  <td>
                                    <td colspan="3" style={{ textAlign: "center" }}>
                                      <b>Builtup Area & Fees</b>
                                    </td>
                                    <tr>
                                      <td style={{ width: "300px" }}>
                                        <b>Area(sq.m) * Unit Price</b>
                                      </td>
                                      <td style={{ width: "300px" }}>
                                        <b>Sub Price</b>
                                      </td>
                                      <td style={{ width: "300px" }}>
                                        <b>Price()</b>
                                      </td>
                                    </tr>
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                {item?.feeDetails?.deviationTable?.map((feeData, index) => (
                                  <tr>
                                    {/* <td >{feeData?.floorType?.name}</td> */}
                                    <td>
                                      <b>{feeData?.landUseType?.name}</b>
                                    </td>
                                    <td>
                                      <td style={{ width: "300px" }}>
                                        {feeData?.landUseType?.area} * {feeData?.landUseType?.unitPrice}{" "}
                                      </td>
                                      <td style={{ width: "300px" }}> {feeData?.landUseType?.subPrice}</td>
                                      <td style={{ width: "300px" }}>{feeData?.landUseType?.price}</td>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </>
                      )}
                    </div>

                    {formData?.applicationType === "FORM_11" && item?.applicationFeeDetils?.khasraTable && (
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <td>
                              <p style={{ marginTop: "20px" }}>
                                <b>Plot No</b>
                              </p>
                            </td>
                            <td>
                              <p style={{ marginTop: "20px" }}>
                                <b>plot Area(sqm.) </b>
                              </p>
                            </td>
                            <td>
                              <p style={{ marginTop: "20px" }}>
                                <b>purpose </b>
                              </p>
                            </td>
                            <td>
                              <p style={{ marginTop: "20px" }}>
                                <b>Type of land development</b>
                              </p>
                            </td>
                            <td>
                              <p style={{ marginTop: "20px" }}>
                                <b>Unit Price per SqM</b>
                              </p>
                            </td>
                            <td>
                              <p style={{ marginTop: "20px" }}>
                                <b>Application Fee</b>
                              </p>
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {item?.applicationFeeDetils?.khasraTable?.map((feeData, index) => (
                            <tr>
                              <td>{feeData?.plotNo}</td>
                              <td>
                                <b>{feeData?.plotArea}</b>
                              </td>
                              <td>
                                <b>{feeData?.purpose}</b>
                              </td>
                              <td>
                                <b>{feeData?.typeOfLand}</b>
                              </td>
                              <td>
                                <b>{feeData?.unitPrice}</b>
                              </td>
                              <td>
                                <b>{feeData?.applicationFee}</b>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                    <table class="table table-sm">
                      {formData?.applicationType != "FORM_MT" && (
                        <thead>
                          <p style={{ marginLeft: "10px", textAlign: "left" }}>
                            <b>Total Amount</b>
                          </p>
                        </thead>
                      )}
                      <tbody>
                        {(item?.applicationFee !== 0 && item?.applicationFee) ||
                          (formData?.taxHeadEstimate?.[0]?.estimateAmount && (
                            <tr>
                              <td colspan="2">{t(`BPA_COMMON_APPLICATION_FEE`)}</td>
                              <td>
                                <b>{`₹ ${item?.applicationFee || formData?.taxHeadEstimate?.[0]?.estimateAmount}`}</b>
                              </td>
                            </tr>
                          ))}
                        {item?.buildingUseFee !== 0 && item?.buildingUseFee && (
                          <tr>
                            <td colspan="2">Development of land Fees</td>
                            <td>
                              <b>{`₹ ${item?.buildingUseFee}`}</b>
                            </td>
                          </tr>
                        )}

                        {formData?.applicationType === "FORM_MT" && (
                          <>
                            {item?.buildUpCharges !== 0 && item?.buildUpCharges && (
                              <tr>
                                <td colspan="2">Building Operation Fees</td>
                                <td>
                                  <b>{`₹ ${item?.buildUpCharges}`}</b>
                                </td>
                              </tr>
                            )}
                          </>
                        )}

                        {formData?.applicationType != "FORM_MT" && (
                          <>
                            {item?.buildUpCharges !== 0 && item?.buildUpCharges && (
                              <tr>
                                <td colspan="2">Building Permission Fee</td>
                                <td>
                                  <b>{`₹ ${item?.buildUpCharges}`}</b>
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                        {item?.cluFee !== 0 && item?.cluFee && (
                          <tr>
                            <td colspan="2">CLU Fee</td>
                            <td>
                              <b>{`₹ ${item?.cluFee}`}</b>
                            </td>
                          </tr>
                        )}

                        {item?.deviationCharges && item?.deviationCharges !== 0 && (
                          <tr>
                            <td colspan="2">Deviation Charges</td>
                            <td>
                              <b>{`₹ ${item?.deviationCharges}`}</b>
                            </td>
                          </tr>
                        )}
                        {item?.muckCharges !== 0 && item?.muckCharges && (
                          <tr colspan="2">
                            <td>Total Muck-Charges</td>
                            <td>
                              <b>{`₹ ${item?.deviationCharges}`}</b>
                            </td>
                          </tr>
                        )}
                        {item?.totalCBMFees !== 0 && item?.totalCBMFees && (
                          <tr>
                            <td colspan="2">
                              <b>Total Planning Permission Fee</b>
                            </td>
                            <td>
                              <b>{`₹ ${item?.totalCBMFees}`}</b>
                            </td>
                          </tr>
                        )}
                        {item?.premiumFARFee !== 0 && item?.premiumFARFee && (
                          <tr>
                            <td colspan="2">Premium FAR Fee</td>
                            <td>
                              <b>{`₹ ${item?.premiumFARFee}`}</b>
                            </td>
                          </tr>
                        )}
                        {item?.echarges !== 0 && item?.echarges && (
                          <tr>
                            <td colspan="2">e-charges (3%)</td>
                            <td>
                              <b>{`₹ ${item?.echarges}`}</b>
                            </td>
                          </tr>
                        )}
                        {item?.amountDisplay !== 0 && item?.amountDisplay && (
                          <tr>
                            <td colspan="2">
                              <b>Grand Total Amount</b>
                            </td>
                            <td>
                              <b>{`₹ ${item?.amountDisplay}`}</b>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </Card>
                </Box>
              ))}
            </React.Fragment>
          )}
        </Box>
        <DialogContentModal
          title={"Application Details"}
          dataOpen={smShow}
          onClose={() => {
            setSmShow(false);
          }}
        >
          {formData?.applicationType === "FORM_LANDUSE" ? (
            <TakeActionItem formType={"formLandUse"} id={formData?.applicationNo} logoData={formData?.department === "DA" ? daLogo : avpLogo} />
          ) : formData?.applicationType === "FORM_PURCHASABLE_FAR" ? (
            <Summary id={formData?.applicationNumber} />
          ) : (
            <LTPSummary formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
          )}
        </DialogContentModal>
        <DialogContentModal
          title={"Application Details"}
          dataOpen={smShowNoc}
          onClose={() => {
            setSmShowNoc(false);
          }}
        >
          <NOCFormatView formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
        </DialogContentModal>
        <DialogContentModal
          title={"Application Payment Details"}
          dataOpen={smShowPayment}
          onClose={() => {
            setSmShowPayment(false);
          }}
        >
          <PaymentPrint id={formData?.applicationNo} />
        </DialogContentModal>
        {/* 12 Form */}
        {formType === "form12" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <ApplicationView12 id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "form12" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistory id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}

        {/* 11 Form */}
        {formType === "form11" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <TakeActionItem id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "form11" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistoryAll id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
        {/* 26 Form */}
        {formType === "form26" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <TakeActionItem id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "form26" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistoryAll id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
        {/* MT Form */}
        {formType === "formMT" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <TakeActionItem id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "formMT" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistoryAll id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
        {/* NOC Form */}
        {formType === "formNOC" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <TakeActionItem id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "formNOC" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistoryAll id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
        {/* CLU Form */}
        {formType === "formCLU" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <TakeActionItem id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "formCLU" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistoryAll id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
      </div>
      {/* )} */}
    </React.Fragment>
  );
};
export default Architect;
